<template>
  <div>
    <sui-dimmer v-if="fetchingEvents" active>
      <sui-loader />
    </sui-dimmer>
    <sui-table selectable celled striped>
      <sui-table-header>
        <sui-table-row>
          <sui-table-header-cell>Creator</sui-table-header-cell>          
          <sui-table-header-cell>Start Date</sui-table-header-cell>
          <sui-table-header-cell>End Date</sui-table-header-cell>
          <sui-table-header-cell>Region</sui-table-header-cell>
          <sui-table-header-cell>Keywords</sui-table-header-cell>
          <sui-table-header-cell></sui-table-header-cell>
        </sui-table-row>
      </sui-table-header>
      <sui-table-body>        
        <sui-table-row v-for="(event, index) in events" :key="event.id" @click="showEvent(event.id)" :warning="event.regionCode=='TW'">
          <sui-table-cell>{{event.creator || 'bot'}}</sui-table-cell>
          <sui-table-cell>{{formatTimestamp(event.startDate)}}</sui-table-cell>
          <sui-table-cell>{{formatTimestamp(event.endDate)}}</sui-table-cell>
          <sui-table-cell>{{formatRegionCode(event.regionCode)}}</sui-table-cell>
          <sui-table-cell>{{event.keywords}}</sui-table-cell>
          <sui-table-cell><sui-button v-if="ownTheEvent(event)" @click.stop="deleteSplash(index)" color="red" size="tiny" icon="trash"></sui-button></sui-table-cell>
        </sui-table-row>
      </sui-table-body>
    </sui-table>
    <sui-button v-if="lastDoc" @click="loadMore()" :loading="fetchingEvents">Load More</sui-button>
    <sui-divider />
    <p v-if="lastDoc">
    最後資料時間：{{formatTimestamp(this.lastDoc.data().endDate)}}
    </p>
  </div>
</template>

<script>
import { mapState, createNamespacedHelpers } from 'vuex';
import regionData from 'country-region-data';

export default {
  props: {
    namespace: String,
  },
  beforeCreate () {
    const moduleNamespace = this.$options.propsData.namespace || 'allEvents';
    const { mapActions, mapState } = createNamespacedHelpers(moduleNamespace);
    Object.assign(this.$options.computed, {
      ...mapState([
          'events',
          'fetchingEvents',
          'lastDoc',
        ]),
    });
    Object.assign(this.$options.methods, {
      ...mapActions([
        'fetchEvents',
        'loadMore',
        'deleteSplash',
      ]),      
    });
  },
  data () {
    return {
    };
  },
  computed: {
    ...mapState([
      'userId',
    ]),
  },
  created() {
    if (this.events && this.events.length > 0) {
      return;
    }
    this.fetchEvents();    
  },
  methods: {
    ownTheEvent (event) {
      return event.creator === this.userId;
    },
    showEvent (id) {
      this.$router.push({ name: 'ShowEvent', params: { id } });
    },
    formatTimestamp (timestamp) {
      return timestamp.toDate().toLocaleString();
    },
    formatRegionCode (regionCode) {
      const region = regionData.find(r => r.countryShortCode === regionCode);
      return (region && region.countryName) || regionCode;
    },
  },
}
</script>